import { Card, Text } from '@radix-ui/themes';
import clsx from 'clsx';
import type { ComponentProps } from 'react';
import type { ClosedMessageDocument } from '@hubertai/screening-question-types';
import { EQuestionType } from '@hubertai/screening-question-types';
import AnswerEvaluation from '../AnswerEvaluation';
import CandidateDatePickerAnswer from './CandidateDatePickerAnswer';
import CandidateFormAnswer from './CandidateFormAnswer';
import CandidateMultipleSelectAnswer from './CandidateMultipleSelectAnswer';
import CandidateSingleSelectAnswer from './CandidateSingleSelectAnswer';
import type { TChatCollection } from 'types/scores.types';

interface CandidateMessageProps extends ComponentProps<'div'> {
  collection: TChatCollection;
  answer: ClosedMessageDocument;
}

const CandidateClosedAnswer = ({ collection, answer, ...props }: CandidateMessageProps) => {
  // console.log('<CandidateClosedAnswer />', answer)
  const question = collection.question;

  if (!question) {
    return <div>Question is missing: {collection.questionId}</div>;
  }

  if (question.type === EQuestionType.SingleSelect) {
    return <CandidateSingleSelectAnswer collection={collection} answer={answer} />;
  } else if (question.type === EQuestionType.MultipleSelect) {
    return <CandidateMultipleSelectAnswer collection={collection} answer={answer} />;
  } else if (question.type === EQuestionType.Form) {
    return <CandidateFormAnswer collection={collection} answer={answer} />;
  } else if (question.type === EQuestionType.DatePicker) {
    return <CandidateDatePickerAnswer collection={collection} answer={answer} />;
  }
  // Audio/Video recording answers are routed directly from ChatCollection (they live in
  // open_answers as RecordingMessageDocument, not ClosedMessageDocument).

  return (
    <div {...props} className={clsx('flex flex-row justify-end gap-2')}>
      <Card className={clsx('max-w-[80%]', 'flex flex-col justify-between', 'p-2')}>
        <Text as="div" size="2" color="gray">
          {/* Echoed from the candidate payload — must never be rendered as HTML (XSS) */}
          <div>{answer.text ?? ''}</div>
        </Text>
      </Card>
      <AnswerEvaluation />
    </div>
  );
};

export default CandidateClosedAnswer;
